<template>
  <div v-if="allTags.length" class="bg-white rounded-lg p-6 mb-6">
    <h2 class="text-xl font-bold text-gray-900 mb-4">{{ t('property.features_and_amenities') }}</h2>

    <!-- Primary Features -->
    <div v-if="primaryTags.length" class="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
      <div
        v-for="tag in primaryTags"
        :key="tag.id"
        class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg"
      >
        <component :is="icons[tag.icon]" v-if="tag.icon" class="size-6 text-brand" />
        <span class="font-semibold text-gray-800">{{ t(`tags.${tag.id}`) }}</span>
      </div>
    </div>

    <!-- Other Features -->
    <div v-if="secondaryTags.length > 0">
      <h3 class="text-lg font-semibold text-gray-800 mb-3">{{ t('property.other_features') || 'Other Features' }}</h3>
      <div class="grid grid-cols-2 gap-3">
        <div
          v-for="tag in secondaryTags"
          :key="tag.id"
          class="flex items-center gap-2 py-3 px-5 bg-gray-50 rounded-lg"
        >
          <div class="w-1 h-1 bg-brand rounded-full"></div>
          <span class="text-gray-700">{{ t(`tags.${tag.id}`) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue';
import { useI18n } from 'vue-i18n';
import { filterTags } from '@repo/modules/tags';
import type { Tag } from '@repo/modules/tags';
import {
  Dog, ParkingSquare, Paintbrush, MountainSnow, Lock, Building, Bike, Motorbike,
  Video, ShieldCheck, Sprout, Package, CookingPot, Accessibility, FileText, Globe,
  ShowerHead, Fan, ThermometerSnowflake, DoorOpen, Soup,
} from 'lucide-vue-next';

const props = defineProps<{
  labels: string[];
}>();

const { t } = useI18n();

const allTags = computed<Tag[]>(() => {
    if (!props.labels) return [];
    return filterTags(props.labels);
});

const primaryTags = computed(() => {
    return allTags.value.filter(tag => tag.primary);
});

const secondaryTags = computed(() => {
    return allTags.value.filter(tag => !tag.primary);
});

const icons: { [key: string]: Component } = {
  Dog, ParkingSquare, Paintbrush, MountainSnow, Lock, Building, Bike, Motorbike,
  Video, ShieldCheck, Sprout, Package, CookingPot, Accessibility, FileText, Globe,
  ShowerHead, Fan, ThermometerSnowflake, DoorOpen, Soup
};
</script>
